module.exports = require('../lib/locale/ru_RU');